import React, { Component } from 'react';

import InputBox from '../../../../etc/InputBox';
import RecordList from '../../../../admin/record'

class Record extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  onChange = (e) => {
    console.log(e);
  };

  render() {
    return (
      <>
        <div className="row mb-2 mt-4">
          <div className="col-md-12">
            <InputBox
              title="논문 명"
              value={[{ value : "Clinical Results of Distal Embolization in Grade V Splenic Injury : Four-Year Experience from a Single Regional Trauma Center" }]}
            />
          </div>
        </div>
        
        <RecordList />
      </>
    )
  }
}

export default Record;
